function EnableCookie(){
    $.post(DOMAIN+"session/", {setsession: "EnableCookie"});
    $("#CookieWarning").fadeOut(function (){
        $(this).remove();
    });
}
$(".sem:not(a)").each(function () {
    var em = $(this).attr("data-e0") + "@" + $(this).attr("data-e1") + "." + $(this).attr("data-e2");
    $(this).html('<a href="mailto:' + em + '">' + em + '</a>');
});
$("a.sem").each(function () {
    var em = $(this).attr("data-e0") + "@" + $(this).attr("data-e1") + "." + $(this).attr("data-e2");
    $(this).attr('href', 'mailto:' + em);
});

$(function(){
    $(window).bind("load resize", function()
    {
        var sfh =  Math.floor ( $('#sticky-footer').outerHeight() );
        $('#page-wrap').css("padding-bottom", sfh+'px');
        $('#page-wrap').css("margin-bottom", ((-1) * sfh)+'px');
    });
});
var wavesConfig = {
    // How long Waves effect duration
    // when it's clicked (in milliseconds)
    duration: 500,

    // Delay showing Waves effect on touch
    // and hide the effect if user scrolls
    // (0 to disable delay) (in milliseconds)
    delay: 10
};


Waves.attach('.btn, .waves, #main-menu .navbar-nav .nav-item, #main-logo','waves-light');
Waves.init(wavesConfig);